import { useState } from 'react'

import { RefObject } from 'react'

import { useEffect } from 'react'

interface IUseIsInViewportOptions {
  rootMargin?: string
}

export const useIsInViewport = (
  elementRef: RefObject<HTMLElement | null>,
  options?: IUseIsInViewportOptions
): boolean => {
  const [isIntersecting, setIsIntersecting] = useState(false)

  useEffect(() => {
    const element = elementRef.current
    if (!element) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting)
      },
      { threshold: 0, rootMargin: options?.rootMargin ?? '0px' } // Can be adjusted from 0 to 1
    )

    observer.observe(element)

    return () => {
      observer.disconnect()
    }
  }, [elementRef, options?.rootMargin])

  return isIntersecting
}
